import React, { FunctionComponent, useEffect, useRef } from 'react';
import { RouteObject, NavLink, useLocation } from 'react-router-dom';
import './PageNavigation.scss';
import { useTranslation } from 'react-i18next';

type Props = {
  routes: Array<RouteObject>;
};

const PageNavigation: FunctionComponent<Props> = ({ routes }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const navRef = useRef<HTMLUListElement>(null);

  useEffect(() => {
    if (navRef.current) {
      const activeLink = navRef.current.querySelector('.app__page-nav-link--active');
      if (activeLink) {
        activeLink.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center',
        });
      }
    }
  }, [location.pathname]);

  return (
    <ul className='app__page-nav' ref={navRef}>
      {routes
        .filter((r) => r.path)
        .map((r) => (
          <NavLink
            className={({ isActive }) =>
              `app__page-nav-link ${isActive ? 'app__page-nav-link--active' : ''}`
            }
            key={`link-${r.path}`}
            to={r.path || ''}
          >
            {r.path &&
              t(
                r.path
                  .split('-')
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(' '),
              )}
          </NavLink>
        ))}
    </ul>
  );
};

export default PageNavigation;
